// components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";

const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated()) {
        sessionStorage.clear(); // optional: clear expired token
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;


// import { getCurrentUser } from "../utils/auth";

// const user = getCurrentUser();
// console.log("Logged in as:", user?.sub); // or user?.username